import React from 'react';
import { Plus, Minus } from 'lucide-react';
interface CanvasToolbarProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onZoomReset: () => void;
  previewCutlines?: boolean;
  onTogglePreviewCutlines?: () => void;
}
export function CanvasToolbar({
  zoom,
  onZoomIn,
  onZoomOut,
  onZoomReset,
  previewCutlines = true,
  onTogglePreviewCutlines
}: CanvasToolbarProps) {
  return <div className="flex items-center gap-4 bg-white rounded-lg shadow-sm border border-gray-200 px-4 py-2" data-id="element-18">
      {onTogglePreviewCutlines && <>
          <div className="flex items-center gap-2" data-id="element-19">
            <span className="text-sm font-medium text-gray-700" data-id="element-20">Cutlines</span>
            <button onClick={onTogglePreviewCutlines} className={`w-8 h-4 rounded-full transition-colors relative ${previewCutlines ? 'bg-[#008696]' : 'bg-gray-200'}`} data-id="element-21">
              <div className={`w-3 h-3 bg-white rounded-full absolute top-0.5 transition-transform ${previewCutlines ? 'left-4.5' : 'left-0.5'}`} style={{
            transform: previewCutlines ? 'translateX(16px)' : 'translateX(0)'
          }} data-id="element-22" />
            </button>
          </div>
          <div className="h-4 w-px bg-gray-200" data-id="element-23" />
        </>}
      <div className="flex items-center gap-2" data-id="element-24">
        <button onClick={onZoomOut} disabled={zoom <= 25} className="p-1 hover:bg-gray-100 rounded text-gray-500 disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-25">
          <Minus size={16} data-id="element-26" />
        </button>
        <span className="text-sm font-medium text-gray-700 min-w-[40px] text-center" data-id="element-27">
          {zoom}%
        </span>
        <button onClick={onZoomIn} disabled={zoom >= 200} className="p-1 hover:bg-gray-100 rounded text-gray-500 disabled:opacity-30 disabled:cursor-not-allowed" data-id="element-28">
          <Plus size={16} data-id="element-29" />
        </button>
      </div>
      <div className="h-4 w-px bg-gray-200" data-id="element-30" />
      <button onClick={onZoomReset} className="text-sm text-gray-500 hover:text-gray-900" data-id="element-31">
        Reset
      </button>
    </div>;
}